<template>
  <div id="app" @contextmenu.prevent @selectstart.prevent @dragstart.prevent>
    <router-view :key="key"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router";
import store from "@/store";

export default {
  name: "Layout",
  data() {
    return {};
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
  },
  created() {
    this.$store.dispatch('menu/requestConfig').then(res => {
    })
  },
  mounted() {
    document.addEventListener('copy', this.handleCopy);
    document.addEventListener('cut', this.handleCut);
  },
  beforeDestroy() {
    document.removeEventListener('copy', this.handleCopy);
    document.removeEventListener('cut', this.handleCut);
  },
  methods: {
    handleCopy(e) {
      e.preventDefault();
    },
    handleCut(e) {
      e.preventDefault();
    },
  },
};
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
} */

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>